module.exports = __webpack_public_path__ + "43257e61c66431c48641afb93541c2b9.svg";